import { Controller } from "@hotwired/stimulus"

// Controla el filtrado de monedas basado en la pasarela de pago seleccionada
// Uso:
// - En el contenedor: data-controller="gateway-currency-filter"
// - En el select de pasarela: data-gateway-currency-filter-target="gatewaySelect" data-action="change->gateway-currency-filter#filterCurrencies"
// - En el select de moneda: data-gateway-currency-filter-target="currencySelect"
// - En las opciones de moneda: data-gateways-ids="[array_de_gateway_ids]"
export default class extends Controller {
  static targets = ["gatewaySelect", "currencySelect"]

  connect() {
    console.log("Gateway Currency Filter controller connected")
    // Filtrar monedas al conectar si ya hay una pasarela seleccionada
    this.filterCurrencies()
  }

  filterCurrencies() {
    const selectedGateway = this.gatewaySelectTarget.value
    console.log("Selected gateway:", selectedGateway)
    
    // Si no hay pasarela seleccionada, habilitar todas las monedas
    if (!selectedGateway) {
      this.enableAllCurrencies()
      return
    }

    // Obtener todas las opciones de moneda
    const currencyOptions = this.currencySelectTarget.querySelectorAll('option')
    const enabledCurrencies = []
    
    currencyOptions.forEach(option => {
      // Saltar la opción prompt (vacía)
      if (!option.value) {
        return
      }

      // Obtener los gateway IDs soportados por esta moneda
      const supportedGateways = this.getSupportedGateways(option)
      
      // Habilitar/deshabilitar la opción basado en si la pasarela seleccionada la soporta
      if (supportedGateways.includes(selectedGateway)) {
        option.disabled = false
        option.style.display = ''
        enabledCurrencies.push(option)
        console.log(`Currency ${option.value} enabled for gateway ${selectedGateway}`)
      } else {
        option.disabled = true
        option.style.display = 'none'
        console.log(`Currency ${option.value} disabled for gateway ${selectedGateway}`)
        
        // Si esta moneda estaba seleccionada, limpiar la selección
        if (option.selected) {
          this.currencySelectTarget.value = ''
        }
      }
    })

    // Si solo queda una moneda válida, seleccionarla automáticamente
    if (enabledCurrencies.length === 1) {
      const singleCurrency = enabledCurrencies[0]
      this.currencySelectTarget.value = singleCurrency.value
      console.log(`Auto-selected currency ${singleCurrency.value} as it's the only valid option`)
    }
  }

  enableAllCurrencies() {
    const currencyOptions = this.currencySelectTarget.querySelectorAll('option')
    
    currencyOptions.forEach(option => {
      option.disabled = false
      option.style.display = ''
    })
    
    console.log("All currencies enabled")
  }

  getSupportedGateways(option) {
    // Obtener el atributo data-gateways-ids de la opción
    const gatewaysData = option.dataset.gatewaysIds
    
    if (!gatewaysData) {
      console.warn(`No gateways data found for currency option ${option.value}`)
      return []
    }

    try {
      // El helper de Rails debería generar un array JSON
      return JSON.parse(gatewaysData)
    } catch (error) {
      console.error(`Error parsing gateways data for ${option.value}:`, error)
      return []
    }
  }
}
